export default "__VITE_ASSET__fXT5I8md__"